import { DropdownProps } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import Select, { components } from 'react-select';
import { useMobile } from '../../hooks/useMobile';
import { getOutsideUrl } from '../../utils/getOutsideUrl';
import SideBarMenu from '../SidebarMenu';
import './index.css';
import check from '../../assets/icons/check.svg';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/state';
interface Props {
  setLang: React.Dispatch<React.SetStateAction<string>>;
  lang: string;
}

const selectedItemTemplate = (option: any, prop: DropdownProps) => {
  return option.label.split(' ')[0];
};
const CustomOption = (props: any) => {
  const splitLabel = props.data.label.split('|');
  return (
    <components.Option {...props}>
      <span className="item--label font-bold">{splitLabel[0]}</span>
      {splitLabel[1] ? <span className="pl-2">|</span> : ''}
      <span className="item--native pl-2">{splitLabel[1]}</span>
    </components.Option>
  );
};

const SingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <span className="uppercase text-xs font-medium block w-full text-right">
        {props.data.label.split('|')[0]?.split('(')[0]}
      </span>
    </components.SingleValue>
  );
};

const DropDownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <i
        className="pi pi-chevron-down"
        style={{ fontSize: '8px', marginLeft: '-0.5rem' }}
      />
    </components.DropdownIndicator>
  );
};

const itemTemplate = (option: any) => {
  const splitLabel = option.label.split('|');
  return (
    <>
      <span className="item--label font-bold">{splitLabel[0]}</span>
      {splitLabel[1] ? <span className="pl-2">|</span> : ''}
      <span className="item--native pl-2">{splitLabel[1]}</span>
    </>
  );
};

const getLanguage = (lang: string) => {
  switch (lang) {
    case 'en':
      return 'EN';
    case 'de':
      return 'DE';
    case 'zh':
      return 'ZH';
    case 'fi':
      return 'FI';
    case 'it':
      return 'IT';
    default:
      return 'EN';
  }
};
const Header: React.FC<Props> = ({ lang, setLang }) => {
  const isMobile = useMobile();
  const [visible, setVisible] = useState(false);
  const { configurations, products } = useSelector(
    (state: RootState) => state.qoute
  );
  let activeClassName = 'nav-active';
  const { t } = useTranslation();
  const languageList = [
    { label: t('ENGLISH'), value: 'en' },
    { label: t('GERMAN'), value: 'de' },
    { label: t('CHINESE'), value: 'zh' },
    { label: t('FINISH'), value: 'fi' },
    { label: t('ITALIN'), value: 'it' },
  ];
  useEffect(() => {
    let script = null;
    const cookie = document.getElementById('CookieConsent');
    if (cookie) {
      cookie.setAttribute('data-culture', getLanguage(lang));
      (window as any).CookieInformation?.loadConsent();
    } else {
      script = document.createElement('script');
      script.src = 'https://policy.app.cookieinformation.com/uc.js';
      script.type = 'text/javascript';
      script.id = 'CookieConsent';
      script.dataset.culture = getLanguage(lang);
      document.body.appendChild(script);
      script.onload = () => {
        import('./cookie.js').then((src) => src.default());
      };
    }
  }, [lang]);

  return (
    <header className="tbl-header ">
      <div className="tbc-gd__wrap">
        <div className="tbl-htopbar">
          <div className="tbl-htopbar__left">
            <div className="tbl-hbrand">
              <a
                href={getOutsideUrl('')}
                target="_blank"
                className="tbl-hbrand__logo"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  viewBox="0 0 175 74.75"
                  style={{ height: '100%' }}
                >
                  <g fill="#d4a92f">
                    <path d="M65.945 9.192h3.177V27.41h-3.177z"></path>
                    <path d="M56.692 7.393h21.913v3.177H56.692zm-1.527-5.301v3.574h30.214L67.514 34.327 49.71 5.666h5.455V2.092H43.242l24.272 38.947L91.785 2.092zm61.092 0l-1.327 3.574h8.966l-17.864 28.661-4.342-6.991-2.088 3.423 6.43 10.28 24.273-38.947z"></path>
                    <path d="M103.656 2.092l-1.769 3.574h9.237L93.258 34.327l-4.286-7.029-2.086 3.499 6.372 10.242 24.273-38.947z"></path>
                    <path d="M90.023 2.092l-1.102 3.574h9.415L80.473 34.327l-4.413-6.978-2.123 3.445 6.536 10.245 24.27-38.947z"></path>
                  </g>
                  <g fill="#fff">
                    <path d="M22.351 60.718v9.63c0 1.318.2 1.475.773 1.913H18.71c.574-.438.774-.595.774-1.913V49.667c0-1.321-.2-1.477-.774-1.916h6.594c6.161 0 8.713 1.977 8.713 6.78 0 2.199-1.662 5.056-5.217 5.747l4.987 10.069c.888 1.444 1.033 1.506 1.519 1.913h-3.754l-5.531-11.543-1.158-2.092c2.15 0 6.287-.108 6.287-4.125 0-2.669-1.461-4.553-5.846-4.553h-2.953v10.771m116.76 0v9.63c0 1.318.201 1.475.777 1.913h-4.416c.571-.438.773-.595.773-1.913V49.667c0-1.321-.202-1.477-.773-1.916h6.592c6.164 0 8.713 1.977 8.713 6.78 0 2.199-1.661 5.056-5.215 5.747l4.987 10.069c.888 1.444 1.03 1.506 1.519 1.913h-3.756l-5.53-11.543-1.157-2.092c2.15 0 6.287-.108 6.287-4.125 0-2.669-1.462-4.553-5.848-4.553h-2.953v10.771"></path>
                    <path d="M37.89 49.652c0-1.321-.201-1.477-.773-1.916h13.098v3.202c-.286-.378-.372-1.005-1.948-1.005h-7.51v7.755l5.192.112c1.49 0 1.547-.282 1.892-.722v3.642c-.287-.376-.287-.72-1.806-.72l-5.278-.114v10.178h7.51c1.547 0 1.576-.562 1.948-1.005v3.202H37.117c.572-.439.773-.595.773-1.913V49.652m15.447-.111c0-1.318-.201-1.477-.773-1.916h4.413c-.574.439-.774.598-.774 1.916v20.523h5.66c1.55 0 1.608-.629 1.949-1.006v3.202H52.564c.572-.439.773-.595.773-1.913V49.541m13.188 0c0-1.318-.2-1.477-.773-1.916h4.414c-.574.439-.774.598-.774 1.916v20.523h5.271c1.547 0 1.604-.629 1.948-1.006v3.202H65.752c.573-.439.773-.595.773-1.913V49.541m12.959 1.635c0-2.604-.2-2.763-.773-3.202h13.097v3.205c-.285-.378-.373-1.008-1.949-1.008h-7.508v7.351l5.522.114c1.491 0 1.55-.282 1.894-.724v3.642c-.289-.375-.289-.721-1.806-.721l-5.61-.114v10.345h7.508c1.548 0 1.576-.562 1.949-1.005v3.202H78.711l.773-.63V51.176m15.528-1.281c0-1.317-.201-1.476-.775-1.916h6.106c4.069 0 8.513.537 8.513 5.685 0 3.548-2.322 5.168-4.156 5.48v.065c2.062 0 5.476 1.743 5.476 6.296 0 6.34-6.02 6.756-9.832 6.756h-6.106c.574-.439.775-.595.775-1.913V49.895m2.872 8.883l-.009 11.285h2.467c3.267 0 6.964-.416 6.964-4.685 0-4.146-3.248-5.769-6.861-5.769-1.121 0 0-.668 0-.668 4.412 0 5.429-2.077 5.544-4.998 0-3.671-3.039-3.765-5.646-3.765h-2.467l.008 8.6zm24.842-11.152c-6.748 0-11.166 6.049-11.166 12.661s4.635 12.464 11.071 12.464c6.779 0 11.039-6.249 11.039-12.464 0-6.712-4.478-12.661-10.944-12.661zm-.063 22.643c-4.977 0-7.992-5.024-7.992-10.049 0-5.256 3.079-10.113 8.021-10.113 4.603 0 7.869 4.661 7.869 10.113 0 4.892-2.923 10.049-7.898 10.049zm45.816-9.217l-2.686.015c-1.521 0-1.521.346-1.805.724v-3.642c.342.439.402.721 1.89.721l5.918-.016v-.102V70.4c-2.024 1.343-5.142 2.347-7.894 2.347-6.863 0-11.407-4.963-11.407-12.475 0-7.613 4.976-13.014 11.407-13.014 3.88 0 5.339 1.845 6.367 1.845.299 0 .465-.134.762-.368v4.729c-.297-.302-2.619-3.688-6.665-3.688-4.938 0-8.556 4.427-8.556 10.43 0 5.533 3.15 10.028 8.356 10.028 1.494 0 2.886-.337 4.312-1.04v-8.142M16.94 47.648v3.17c-.43-.472-.459-.973-1.92-.973h-4.242l.002 20.502c0 1.318.199 1.474.773 1.913H7.14c.573-.439.775-.595.775-1.913l-.001-20.501H3.728c-1.52 0-1.547.501-1.978.973v-3.17h15.19"></path>
                  </g>
                </svg>
              </a>
            </div>
            <div className="app-title">ANTIVIBRATION SOLUTIONS</div>
          </div>
          <div className="tbl-htopbar__right relative">
            <div className="tbl-hsplitter"></div>
            {isMobile ? (
              <SideBarMenu
                visible={visible}
                setVisible={setVisible}
                value={lang}
                options={languageList}
                valueTemplate={selectedItemTemplate}
                itemTemplate={itemTemplate}
                onChange={(e: any) => {
                  setLang(e.value);
                  setVisible(false);
                }}
              />
            ) : (
              <div className="tb-header__right flex align-items-center">
                <div
                  className="dropdown-container dropdown-container-alt"
                  style={{ width: '34ch' }}
                >
                  <Select
                    options={languageList}
                    value={{
                      label: languageList.find((l) => l.value === lang)?.label,
                      value: lang,
                    }}
                    onChange={(e) => {
                      e?.value && setLang(e.value);
                    }}
                    classNamePrefix="tb"
                    // menuIsOpen={true}
                    isSearchable={false}
                    components={{
                      SingleValue,
                      IndicatorSeparator: () => null,
                      ClearIndicator: () => null,
                      Option: CustomOption,
                      DropdownIndicator: DropDownIndicator,
                    }}
                  ></Select>
                  {/* <Dropdown
                    panelClassName="tb-header__right__panel"
                    value={lang}
                    options={languageList}
                    valueTemplate={selectedItemTemplate}
                    itemTemplate={itemTemplate}
                    onChange={(e) => {
                      setLang(e.value);
                    }}
                    appendTo={
                      document.querySelector(".tb-header__right") as HTMLElement
                    }
                    scrollHeight="400px"
                  ></Dropdown> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {!isMobile && (
        <nav className="navbar flex justify-content-center">
          <section className="flex">
            <NavLink
              className={({ isActive }) => (isActive ? activeClassName : '')}
              to={'/'}
            >
              {t('HOME')}
            </NavLink>
            <NavLink
              className={({ isActive }) => (isActive ? activeClassName : '')}
              to={'/configurator'}
            >
              {t('CONFIGURATOR')}
            </NavLink>
            <NavLink
              className={({ isActive }) => {
                return isActive || window.location.href.includes('summary')
                  ? activeClassName
                  : '';
              }}
              to={'/saveQuote'}
            >
              <div className="relative">
                {t('SAVE_QUOTE')}{' '}
                {products.length || configurations.length ? (
                  <img
                    src={check}
                    alt="rfq"
                    width={20}
                    style={{
                      right: '-14px',
                      top: '-6px',
                    }}
                    height={20}
                    className="absolute"
                  />
                ) : (
                  ''
                )}
              </div>
            </NavLink>
          </section>
        </nav>
      )}
    </header>
  );
};

export default Header;
